export const isVoucherProUser = () => {
  const user = JSON.parse(localStorage.getItem('auth-user'));

  return !!user?.permissions.some(
    (permission) =>
      permission.role_id === 'DASH_CVE_PRO_CREATE_VOUCHER' &&
      !!permission.status,
  );
};
